/* Announcement Bar js */

$(window).on("load", function() {
    $("#tps_announcement_slider").show().slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      arrows: true,
      dots: false
    });
  });

